import { getAbout } from "@/api/about";
export default {
  namespaced: true,
  state: {
    loading: true,
    data: null,
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setData(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    async getData(cxt) {
      if (cxt.state.data) {
        return;
      }
      cxt.commit("setLoading", true);
      const res = await getAbout();
      cxt.commit("setData", res);
      cxt.commit("setLoading", false);
    },
  },
};
